import type { ReactNode } from "react";
import { useSection, useSections } from "./hooks";

export function Active({ children }: { children: ReactNode }) {
    const { active } = useSections();
    const { sectionId, ref } = useSection();

    if (active !== sectionId) return null;

    return (
        <div
            ref={ref}
            className="bg-compendia-greige-10 border-compendia-greige rounded-card border p-6 shadow-sm"
        >
            {children}
        </div>
    );
}
